module.exports = __webpack_public_path__ + "static/media/6.3618bd65.jpg";